// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gzt1","left":"styles_left__2nRc7"};